import { Dispatch, SetStateAction } from "react";
import {
    Modal,
    Button,
    TextField,
    MenuItem,
    IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

interface ModalProps {
    open: boolean;
    onClose: () => void;
    setOpen: Dispatch<SetStateAction<boolean>>;
}

export default function AddAttributes({
    open,
    onClose,
    setOpen,
}: ModalProps) {

    return (
        <Modal className="modal rejectReason_modal" open={open} onClose={onClose}>
            <div className="modal-dialog" >
                <div className="modal-body">
                    {/* HEADER */}
                    <div className="modal_title">
                        <h2>Add Attribute</h2>
                        <IconButton
                            onClick={() => setOpen(false)}
                        >
                            <CloseIcon sx={{ fontSize: '18px' }} />
                        </IconButton>
                    </div>

                    {/* FORM */}
                    <div className="form">
                        <div className="control_group" >
                            <label htmlFor="attribute-name">
                                Attribute Name <span style={{ color: 'red' }}>*</span>
                            </label>
                            <TextField
                                fullWidth
                                placeholder="Attribute Name"
                                variant="outlined"
                                inputProps={{ id: "attribute-name" }}
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        '& fieldset': { borderColor: '#e2e8f0' },
                                        '&:hover fieldset': { borderColor: '#cbd5e1' },
                                        '&.Mui-focused fieldset': { borderColor: '#00A170' },
                                    }
                                }}
                            />
                        </div>

                        <div className="control_group" >
                            <label htmlFor="attribute-type">
                                Attribute Type
                            </label>
                            <TextField
                                select
                                fullWidth
                                defaultValue="Select"
                                variant="outlined"
                                inputProps={{ id: "attribute-type" }}
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        '& fieldset': { borderColor: '#00A170' },
                                        '&:hover fieldset': { borderColor: '#00A170' },
                                        '&.Mui-focused fieldset': { borderColor: '#00A170' },
                                    }
                                }}
                                SelectProps={{
                                    renderValue: (value: any) => value === "" ? "Select Attribute Type" : value
                                }}
                            >
                                <MenuItem value="" disabled style={{ display: 'none' }}>Select Attribute Type</MenuItem>
                                <MenuItem value="Text">Text</MenuItem>
                                <MenuItem value="Number">Number</MenuItem>
                                <MenuItem value="Color">Color</MenuItem>
                            </TextField>
                        </div>

                        {/* FOOTER */}
                        <div className="footer_btn_flex" style={{ display: 'flex', justifyContent: 'flex-end', gap: '15px', marginTop: '10px' }}>
                            <Button
                                className="btn btn_grey"
                                variant="outlined"
                                onClick={() => setOpen(false)}
                            >
                                Cancel
                            </Button>
                            <Button
                                className="btn btn_primary"
                                onClick={() => setOpen(false)}
                            >
                                Save Attribute
                            </Button>
                        </div>
                    </div>
                </div >
            </div >
        </Modal >
    );
}
